import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import axios from 'axios';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly currencies$ = new BehaviorSubject<string[] | null>(null);
  private loadPromise: Promise<string[]> | null = null;

  async getAllowedCurrencies(): Promise<string[]> {
    const cached = this.currencies$.value;
    if (cached !== null) {
      return cached;
    }
    if (this.loadPromise === null) {
      this.loadPromise = this.fetchCurrencies();
    }
    return this.loadPromise;
  }

  private async fetchCurrencies(): Promise<string[]> {
    const result = await axios.get<{
      currencies: string[];
    }>(`${environment.baseUrl}/api/case-form/currency`);
    const currencies = result.data.currencies;
    this.currencies$.next(currencies);
    return currencies;
  }
}
